import { useSyncExternalStore } from 'react'

export type RequestTopic = 'survey' | 'partnership' | 'careers' | 'press'

export interface AppState {
    loaded: boolean
    stageReady: boolean
    menuOpen: boolean
    requestOpen: boolean
    requestTopic: RequestTopic
}

const initialState: AppState = {
    loaded: false,
    stageReady: false,
    menuOpen: false,
    requestOpen: false,
    requestTopic: 'survey'
}

let appState: AppState = initialState

const listeners = new Set<() => void>()

export const getAppState = (): AppState => appState

export const setAppState = (patch: Partial<AppState>): void => {
    appState = { ...appState, ...patch }
    listeners.forEach(listener => listener())
}

export const subscribeAppState = (listener: () => void): (() => void) => {
    listeners.add(listener)

    return () => {
        listeners.delete(listener)
    }
}

export const useAppState = <T>(selector: (state: AppState) => T): T => {
    return useSyncExternalStore(
        subscribeAppState,
        () => selector(appState),
        () => selector(initialState)
    )
}

export const openRequest = (topic: RequestTopic = 'survey'): void => {
    setAppState({ requestOpen: true, requestTopic: topic, menuOpen: false })
}
